"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePropertyRepair = exports.propertyRepairSchema = void 0;
/* eslint-disable camelcase */
var schema_validator_1 = require("@hobt/schema-validator");
var constants_1 = require("../../constants");
exports.propertyRepairSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    required: ['amount', 'borrowerChargeCode', 'cmhcLoanAccountNumber'],
    properties: {
        amount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        borrowerChargeCode: {
            type: 'string',
            enum: [constants_1.BorrowerChargesCode.PropertyRepairs],
            errorMessage: 'Should equate to a valid BorrowerChargesCode propertyRepair enum value',
        },
        cmhcLoanAccountNumber: {
            type: 'number',
            maximum: 99999999,
            minimum: 10000000,
            errorMessage: 'should be a numeric value with 8 digits',
        },
        preApprovedPropertyRepairID: {
            type: ['string', 'null'],
            format: 'uuid',
            errorMessage: 'Should follow UUID format 00000000-0000-0000-0000-000000000000 or null',
        },
    },
};
exports.validatePropertyRepair = function (data, addAuditFields) {
    if (addAuditFields === void 0) { addAuditFields = false; }
    var propertyRepairValidator = new schema_validator_1.SchemaValidator(exports.propertyRepairSchema, true, true, true, true);
    if (addAuditFields) {
        propertyRepairValidator.extendSchema(schema_validator_1.auditFieldsSchema);
    }
    return propertyRepairValidator.validate(data);
};
